/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { OrganisationEmailSettingsBox_OrganisationFragmentDoc, OrganisationEmailSettingsBox_OrganisationEmailSettingsFragmentDoc, OrganisationEmailSettingsBox_OrganisationEmailTemplateFragmentDoc } from '../../features/organisations/boxes/OrganisationEmailSettingsBox.generated.js';
import { OrganisationEmbeddableWizardSnippetBox_OrganisationFragmentDoc, OrganisationEmbeddableWizardSnippetBox_SettingsFragmentDoc } from '../../features/organisations/boxes/OrganisationEmbeddableWizardSnippetBox.generated.js';
import { OrganisationBillOfMaterialsSettingsBox_SettingsFragmentDoc } from '../../features/organisations/boxes/OrganisationBillOfMaterialsSettingsBox.generated.js';
import { OrganisationProjectDefaultSettingsBox_SettingsFragmentDoc } from '../../features/organisations/boxes/OrganisationProjectDefaultSettingsBox.generated.js';
import { OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc } from '../../features/organisations/boxes/OrganisationAutomatedWorkflowsBox.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationSettingsIntegrationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationSettingsIntegrationsQuery = { viewer?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, title: string, isCraftsmanOrganisation: boolean, integrationM1MsysId: string, smtpEnabled: boolean, smtpSettings?: { __typename: 'OrganisationSmtpSettings', smtpHost?: string | null, smtpPort?: number | null, smtpSecurity?: string | null, smtpUsername?: string | null, smtpFromEmail?: string | null } | null } } | null, organisationSettings: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationSetting', id: string, embeddableWizardIsLeadAddressRequired: boolean, billOfMaterialsExportSettings: { __typename: 'OrganisationSettingBillOfMaterialsExportSettings', dataFormat: Types.BillOfMaterialsDataFormat, sections: Array<Types.BillOfMaterialsSection>, csvFields: Array<Types.BillOfMaterialsField>, pdfFields: Array<Types.BillOfMaterialsField> }, projectDefaultAttachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> }, organisationEmailSettings: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationEmailSettings', id: string, replyToAddress?: string | null }, organisationEmailTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationEmailTemplatesResult', emailTemplates: Array<{ __typename: 'OrganisationEmailTemplate', id: string, description: string, context: Types.EmailTemplateContext, subject: string, content: string, attachments: Array<{ __typename: 'Attachment', id: string, url: string, title: string, mimeType: string, group: string }> }> }, organisationWorkflows: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationWorkflowsResult', workflows: Array<{ __typename: 'OrganisationWorkflow', id: string, workflowType: string, description: string, active: boolean, triggerEventNames: Array<string>, triggerFilter: any, config: any, createdAt: any, updatedAt: any }> } };

export type OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation = { invalidatePrefixOrgCache?: boolean | null };


export const OrganisationSettingsIntegrationsDocument = gql`
    query OrganisationSettingsIntegrations {
  viewer {
    ... on Viewer {
      id
      organisation {
        id
        title
        isCraftsmanOrganisation
        integrationM1MsysId
        ...OrganisationEmailSettingsBox_Organisation
        ...OrganisationEmbeddableWizardSnippetBox_Organisation
      }
    }
  }
  organisationSettings {
    ... on OrganisationSetting {
      id
      ...OrganisationBillOfMaterialsSettingsBox_Settings
      ...OrganisationProjectDefaultSettingsBox_Settings
      ...OrganisationEmbeddableWizardSnippetBox_Settings
    }
  }
  organisationEmailSettings {
    ... on OrganisationEmailSettings {
      id
      ...OrganisationEmailSettingsBox_OrganisationEmailSettings
    }
  }
  organisationEmailTemplates {
    ... on OrganisationEmailTemplatesResult {
      emailTemplates {
        id
        description
        ...OrganisationEmailSettingsBox_OrganisationEmailTemplate
      }
    }
  }
  organisationWorkflows {
    ... on OrganisationWorkflowsResult {
      workflows {
        ...OrganisationAutomatedWorkflowsBox_OrganisationWorkflow
      }
    }
  }
}
    ${OrganisationEmailSettingsBox_OrganisationFragmentDoc}
${OrganisationEmbeddableWizardSnippetBox_OrganisationFragmentDoc}
${OrganisationBillOfMaterialsSettingsBox_SettingsFragmentDoc}
${OrganisationProjectDefaultSettingsBox_SettingsFragmentDoc}
${OrganisationEmbeddableWizardSnippetBox_SettingsFragmentDoc}
${OrganisationEmailSettingsBox_OrganisationEmailSettingsFragmentDoc}
${OrganisationEmailSettingsBox_OrganisationEmailTemplateFragmentDoc}
${OrganisationAutomatedWorkflowsBox_OrganisationWorkflowFragmentDoc}`;

/**
 * __useOrganisationSettingsIntegrationsQuery__
 *
 * To run a query within a React component, call `useOrganisationSettingsIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationSettingsIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationSettingsIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationSettingsIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationSettingsIntegrationsQuery, OrganisationSettingsIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationSettingsIntegrationsQuery, OrganisationSettingsIntegrationsQueryVariables>(OrganisationSettingsIntegrationsDocument, options);
      }
export function useOrganisationSettingsIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationSettingsIntegrationsQuery, OrganisationSettingsIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationSettingsIntegrationsQuery, OrganisationSettingsIntegrationsQueryVariables>(OrganisationSettingsIntegrationsDocument, options);
        }
export function useOrganisationSettingsIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationSettingsIntegrationsQuery, OrganisationSettingsIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationSettingsIntegrationsQuery, OrganisationSettingsIntegrationsQueryVariables>(OrganisationSettingsIntegrationsDocument, options);
        }
export type OrganisationSettingsIntegrationsQueryHookResult = ReturnType<typeof useOrganisationSettingsIntegrationsQuery>;
export type OrganisationSettingsIntegrationsLazyQueryHookResult = ReturnType<typeof useOrganisationSettingsIntegrationsLazyQuery>;
export type OrganisationSettingsIntegrationsSuspenseQueryHookResult = ReturnType<typeof useOrganisationSettingsIntegrationsSuspenseQuery>;
export type OrganisationSettingsIntegrationsQueryResult = Apollo.QueryResult<OrganisationSettingsIntegrationsQuery, OrganisationSettingsIntegrationsQueryVariables>;
export const OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheDocument = gql`
    mutation OrganisationSettingsIntegrations_InvalidatePrefixOrgCache {
  invalidatePrefixOrgCache
}
    `;
export type OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutationFn = Apollo.MutationFunction<OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation, OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutationVariables>;

/**
 * __useOrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation__
 *
 * To run a mutation, you first call `useOrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationSettingsIntegrationsInvalidatePrefixOrgCacheMutation, { data, loading, error }] = useOrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation, OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation, OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutationVariables>(OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheDocument, options);
      }
export type OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutationHookResult = ReturnType<typeof useOrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation>;
export type OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutationResult = Apollo.MutationResult<OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation>;
export type OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutationOptions = Apollo.BaseMutationOptions<OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutation, OrganisationSettingsIntegrations_InvalidatePrefixOrgCacheMutationVariables>;